var _objectSpread = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectSpread2").default;
var _objectWithoutProperties = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectWithoutProperties").default;
var _excluded = ["class", "staticClass", "style", "staticStyle", "attrs"];
require("core-js/modules/es.array.concat.js");
module.exports = {
  functional: true,
  render: function render(_h, _vm) {
    var _c = _vm._c,
      _v = _vm._v,
      data = _vm.data,
      _vm$children = _vm.children,
      children = _vm$children === void 0 ? [] : _vm$children;
    var classNames = data.class,
      staticClass = data.staticClass,
      style = data.style,
      staticStyle = data.staticStyle,
      _data$attrs = data.attrs,
      attrs = _data$attrs === void 0 ? {} : _data$attrs,
      rest = _objectWithoutProperties(data, _excluded);
    return _c('svg', _objectSpread({
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "width": "16",
        "height": "16",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs)
    }, rest), children.concat([_c('path', {
      attrs: {
        "d": "M13.888 9.22H13.4a.47.47 0 01-.458-.458c0-.244-10.037.458-10.281.458h-.61c-.519 0-.946-.304-1.16-.762-.182-.488-.09-1.007.275-1.373l5.919-5.919a1.252 1.252 0 011.77 0l5.918 5.919c.366.366.457.885.274 1.373-.213.457-.64.762-1.159.762zM5.956 15.2H3.851a1.693 1.693 0 01-1.678-1.678V8.946a.47.47 0 01.457-.458c.164 0 1.272 1.932 3.326 5.797a.47.47 0 01.458.457.47.47 0 01-.458.458zm3.802-.166a.47.47 0 01-.569-.445v-4.423H6.75v4.424a.47.47 0 01-.458.457.45.45 0 01-.457-.457L2.63 9.014c0-.43 8.407-.786 10.42-.512a.446.446 0 01.259-.084.47.47 0 01.457.457v4.647a1.673 1.673 0 01-1.678 1.678h-1.983a.46.46 0 01-.347-.166z",
        "fill": "#FFF",
        "fill-rule": "nonzero"
      }
    })]));
  }
};